import React from 'react';

type IslandComponent = React.ComponentType<Record<string, unknown>>;
// Острова типизированы своими пропами; в реестре они хранятся стёртыми (как и в
// eager-регистрации через `as unknown as`). Поэтому лоадер принимает любой
// дефолт-экспорт-компонент.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IslandLoader = () => Promise<{ default: React.ComponentType<any> }>;

const registry = new Map<string, IslandComponent>();
const loaders = new Map<string, IslandLoader>();

export const registerIsland = (name: string, component: IslandComponent): void => {
    registry.set(name, component);
};

/**
 * Регистрирует «ленивый» остров: его код выносится в отдельный чанк и грузится
 * по требованию (при первом рендере под <Suspense>). Loader сохраняется
 * отдельно, чтобы чанк можно было прогреть заранее через preloadIsland —
 * иначе монтирование по клику ждало бы сеть и раздувало INP этого клика.
 */
export const registerLazyIsland = (name: string, loader: IslandLoader): void => {
    registry.set(name, React.lazy(loader) as unknown as IslandComponent);
    loaders.set(name, loader);
};

export const getIsland = (name: string): IslandComponent | undefined => {
    return registry.get(name);
};

/**
 * Прогреть чанк ленивого острова заранее (в простое браузера), чтобы
 * последующее монтирование прошло мгновенно, без ожидания загрузки чанка.
 */
export const preloadIsland = (name: string): void => {
    const loader = loaders.get(name);
    if (loader) {
        // Прогрев не критичен: ошибку сети молча игнорируем, реальный рендер
        // под Suspense повторит импорт и обработает ошибку штатно.
        loader().catch(() => { /* noop */ });
    }
};
